<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="title">
       Thêm ngôn ngữ (JSON)
      </v-card-title>
      <v-card-text style="color: red;">
        Lưu ý: JSON hợp lệ phải sử dụng dấu ngoặc kép và không có dấu phẩy ở cuối.
      </v-card-text>
      <v-card-text>
        <v-form ref="form" lazy-validation class="white mt-3">
          <div style="display: flex;  gap: 10px;">
            <v-textarea
              rows="20"
              ref="vietnameseString"
              v-model="vietnameseString"
              label="Tiếng Việt"
              :rules="[validate.required]"
            ></v-textarea>
            <v-textarea
              rows="20"
              ref="englishString"
              v-model="englishString"
              label="Tiếng Anh"
              :rules="[validate.required]"
            ></v-textarea>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" flat @click="close">Hủy</v-btn>
        <v-btn color="primary" @click="onSubmit" :loading="loading">Thêm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '../../utils/validate';
export default {
  props: { },

  data: () => ({
    dialog: false,
    loading: false,
    vietnameseString: '{\n \n}',
    englishString: '{\n \n}',
    validate: validate
  }),

  methods: {
    ...mapActions(['updateLanguage']),

    open () {
      this.dialog = true;
    },

    onSubmit () {
      if (this.$refs.form.validate()) {
        let vietnameseJson = null;
        let englishJson = null;

        try {
          vietnameseJson = JSON.parse(this.vietnameseString);
          englishJson = JSON.parse(this.englishString);
        } catch (error) {
          window.getApp.showMessage('Lỗi JSON không hợp lệ', 'error');
          return;
        }

        if (!this.compareLanguageKeys(vietnameseJson, englishJson)) {
          window.getApp.showMessage('Khoá ngôn ngữ của tiếng Việt và tiếng Anh không khớp', 'error');
          return;
        }

        const languageRequest = {};

        const allKeys = new Set([...Object.keys(vietnameseJson), ...Object.keys(englishJson)]);

        allKeys.forEach(key => {
          languageRequest[key] = {
            'vi-VN': vietnameseJson[key] || '',
            'en-US': englishJson[key] || ''
          };
        });

        this.loading = true;
        this.updateLanguage(languageRequest).then(() => {
          window.getApp.showMessage('Tạo ngôn ngữ thành công', 'success');
          this.$emit('success', true);
          this.close();
        }).catch(_ => {
          this.loading = false;
          window.getApp.showMessage('Lỗi khi tạo ngôn ngữ', 'error');
        });
      }
    },

    compareLanguageKeys (vietnameseJson, englishJson) {
      const keys1 = Object.keys(vietnameseJson);
      const keys2 = Object.keys(englishJson);

      const missingInSecond = keys1.filter(key => !keys2.includes(key));
      const missingInFirst = keys2.filter(key => !keys1.includes(key));

      const isMatch = missingInSecond.length === 0 && missingInFirst.length === 0;

      return isMatch;
    },

    close () {
      this.dialog = false;
      this.reset();
    },

    reset () {
      this.vietnameseString = '{\n \n}';
      this.englishString = '{\n \n}';
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/language/DialogCreateLanguageJson.vue